module.exports = __webpack_public_path__ + "static/logo-white-5b65fb8ef3df53d4db129ee6b8307466.svg";